const getVendorTypes = () => {
  const vendorTypes = localStorage.getItem("vendorTypes")
    ? JSON.parse(localStorage.getItem("vendorTypes"))
    : null;

  if (vendorTypes) return vendorTypes;

  return null;
};

const getVendors = () => {
  const vendors = localStorage.getItem("vendors")
    ? JSON.parse(localStorage.getItem("vendors"))
    : null;

  if (vendors) return vendors;

  return null;
};

const InitialState = {
  vendorTypes: getVendorTypes(),
  vendors: getVendors(), // Add vendors state
};

const VendorTypesReducer = (state = InitialState, action) => {
  if (action.type === "Save_VendorTypes") {
    const newState = {
      vendorTypes: action.payload,
      vendors: state.vendors, // Preserve existing vendors
    };

    localStorage.setItem("vendorTypes", JSON.stringify(action.payload));

    return newState;
  }

  // Add new action to save vendors
  else if (action.type === "Save_Vendors") {
    const newState = {
      vendorTypes: state.vendorTypes, // Preserve existing vendorTypes
      vendors: action.payload,
    };

    localStorage.setItem("vendors", JSON.stringify(action.payload));

    return newState;
  }


  //logout
  else if (action.type === "Remove_User") {
    const newState = {
      vendorTypes: null,
      vendors: null,
    };

    localStorage.removeItem("vendorTypes");
    localStorage.removeItem("vendors");
    return newState;
  }

  return state;
};

export default VendorTypesReducer;